import { useMemo, useState } from "react";
import { Product_Output } from "@/api/models/Product_Output";
import SummaryCard from "@/components/SummaryCard";
import { Dialog } from "primereact/dialog";

interface ItemMasterSummaryProps {
  itemMaster: Array<Product_Output>
}

const ItemsMasterSummary = ({ itemMaster }: ItemMasterSummaryProps) => {
  const itemCount = itemMaster.length
  const categoryCount = useMemo(() => new Set(itemMaster.map(item => item.category)).size, [itemMaster])
  const dualInspectionCount = useMemo(() => itemMaster.filter(item =>
    Object.values(item.machine_variants || {}).some(variant => variant.is_dual_inspection_compatible)
  ).length, [itemMaster])
  const assemblyCount = useMemo(() => itemMaster.filter(item =>
    Object.values(item.machine_variants || {}).some(variant => variant.requires_assembly)
  ).length, [itemMaster])
  const componentsList = useMemo(() => itemMaster.filter(item => item.components?.length), [itemMaster])
  const componentsCount = componentsList.length
  const notInMoldingList = useMemo(() =>
    itemMaster.filter(item => item.additionalInfo === false && item.components?.length === 0),
    [itemMaster]
  )
  const notInMoldingListCount = notInMoldingList.length

  const [skuDialogState, setSkuDialogState] = useState<{ visible: boolean, title: string, skus: string[] }>({
    visible: false,
    title: "",
    skus: []
  })

  const openSkuDialog = (title: string, skus: string[]) => {
    setSkuDialogState({ visible: true, title, skus })
  }

  const closeSkuDialog = () => setSkuDialogState(prev => ({ ...prev, visible: false }))

  return (
    <>
      <div className="tw-grid tw-grid-cols-3 tw-gap-4 py-4">
        <SummaryCard
          title="品目数"
          target={itemCount}
          className="flex-1/3"
        />
        <SummaryCard
          title="分類数"
          target={categoryCount}
          className="flex-1/3"
        />
        <SummaryCard
          title="2台検査対応"
          target={dualInspectionCount}
          className="flex-1/3"
        />
        <SummaryCard
          title="組立工程有り"
          target={assemblyCount}
          className="flex-1/3"
        />
        <SummaryCard
          title="組品"
          target={componentsCount}
          className="flex-1/3"
          onClick={() => openSkuDialog("組品の品番一覧", componentsList.map(item => item.sku_id))}
        />
        <SummaryCard
          title="成形一覧にない品目"
          target={notInMoldingListCount}
          className="flex-1/3"
          onClick={() => openSkuDialog("成形一覧にない品目の品番一覧", notInMoldingList.map(item => item.sku_id))}
        />
      </div>

      <Dialog
        header={skuDialogState.title}
        visible={skuDialogState.visible}
        style={{ width: "40vw" }}
        onHide={closeSkuDialog}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="tw-max-h-96 tw-overflow-auto">
          {skuDialogState.skus.length === 0 ? (
            <p className="tw-text-sm tw-text-gray-600">該当する品目はありません。</p>
          ) : (
            <ul className="tw-space-y-1 tw-text-sm list-none">
              {skuDialogState.skus.map(sku => (
                <li key={sku} className="tw-font-mono tw-bg-gray-50 tw-border tw-border-gray-200 tw-rounded tw-px-2 tw-py-1">
                  {sku}
                </li>
              ))}
            </ul>
          )}
        </div>
      </Dialog>
    </>
  )
}

export default ItemsMasterSummary
